/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1901821957 — debug() логування */

import { localStorageService } from '../services/local-storage';

const isDevMode =
    import.meta.env.DEV ||
    window.location.hostname.startsWith('hunter-dev') ||
    localStorageService.getItem('DEBUG_IS_ALLOWED') === 'allowed';

type DebugLevel = 'info' | 'warn' | 'error' | 'data' | 'screen' | 'api' | 'state';

const LEVEL_COLORS: Record<DebugLevel, string> = {
    info: 'color: gray',
    warn: 'color: orange',
    error: 'color: red; font-weight: bold',
    data: 'color: greenyellow',
    screen: 'color: green; font-weight: bold',
    api: 'color: skyblue',
    state: 'color: magenta',
};

/**
 * Unified debug logging. Only outputs in dev mode.
 *
 * @example
 * debug('VM connected');                    // gray
 * debug('Order state', 'data', order);      // greenyellow + data
 * debug('API call failed', 'error', error); // red bold + data
 * debug('Payment Screen', 'screen');        // green bold
 */
export function debug(message: string, level: DebugLevel = 'info', ...data: unknown[]): void {
    if (!isDevMode) return;
    console.log(`%c${message}`, `${LEVEL_COLORS[level]}; margin: 5px 10px 0;`, ...data);
}

/** Shorthand for screen entry logging */
export const screenLog = (screenName: string): void => {
    debug(`[${screenName}]`, 'screen');
};

/**
 * @deprecated Use `debug()` instead. Kept for backward compatibility during migration.
 */
export const cl = isDevMode ? console.log : () => {};

/**
 * @deprecated Use `debug()` instead. Kept for backward compatibility during migration.
 */
export const cltext = (text: string, color = 'red') => {
    if (!isDevMode) return;
    console.log(`%c${text}`, `color: ${color}; margin: 5px 10px 0;`);
};

isDevMode && debug('Dev mode active', 'warn');
